import { render, staticRenderFns } from "./GameStats.vue?vue&type=template&id=41eb44da&scoped=true"
import script from "./GameStats.vue?vue&type=script&lang=js"
export * from "./GameStats.vue?vue&type=script&lang=js"
import style0 from "./GameStats.vue?vue&type=style&index=0&id=41eb44da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41eb44da",
  null
  
)

export default component.exports